export const MIXPANEL_EVENTS_LIMITS = {
  LIMITS_REACHED_PARTS: 'limits_reached_parts',
  LIMITS_REACHED_ORG_USERS: 'limits_reached_org_users'
}
